import React, { createContext, useState } from "react";
import { ContextProviderProps } from "../../../types";
import {
  AuthorisedPersonsState,
  UpdateAuthorisedPersonsFunction,
} from "./authorisedPersons.types";

export const initialState = (): AuthorisedPersonsState => {
  return {
    //Response for svaOvlascenaLicaZaPreuzimanjeMarkica

    ovlascenaLica: [],

    //Response for kreirajOvlascenoLiceZaPreuzimanjeMarkica

    kreiranoOvlascenoLice: {
      id: null,
      ime: "",
      prezime: "",
      brojLicneKarte: "",
      datumVazenjaOvlascenjaOd: "",
      datumVazenjaOvlascenjaDo: "",
      aktivno: false,
    },
  };
};

interface IAuthorisedPersonsContext {
  authorisedPersons: AuthorisedPersonsState;
  setAuthorisedPersons: UpdateAuthorisedPersonsFunction;
  clearAuthorisedPersonsState: () => void;
}

export const AuthorisedPersonsContext =
  createContext<IAuthorisedPersonsContext>(null as any);

export const AuthorisedPersonsContextProvider = ({
  children,
}: ContextProviderProps) => {
  const [authorisedPersons, setAuthorisedPersonsState] = useState(
    initialState()
  );

  const handleSetAuthorisedPersons = (
    updatedState: Partial<AuthorisedPersonsState>
  ) => {
    setAuthorisedPersonsState((prev) => ({ ...prev, ...updatedState }));
  };

  const setAuthorisedPersons = (
    updatedState: Partial<AuthorisedPersonsState>
  ) => {
    handleSetAuthorisedPersons({ ...updatedState });
  };

  const clearAuthorisedPersonsState = () => {
    setAuthorisedPersonsState(initialState());
  };

  return (
    <AuthorisedPersonsContext.Provider
      value={{
        authorisedPersons,
        setAuthorisedPersons,
        clearAuthorisedPersonsState,
      }}
    >
      {children}
    </AuthorisedPersonsContext.Provider>
  );
};
